export const GET_LIST_F1 = 'GET_LIST_F1'
export const GET_LIST_F1_SUCCESS = 'GET_LIST_F1_SUCCESS'

export const GET_INFO_F1 = 'GET_INFO_F1'
export const GET_TOTAL_REPORT = 'GET_TOTAL_REPORT'
export const GET_TOTAL_REPORT_SUCCESS = 'GET_TOTAL_REPORT_SUCCESS'

export const INVESTMENT_STATISTIC_REPORT = 'INVESTMENT_STATISTIC_REPORT'
export const INVESTMENT_STATISTIC_REPORT_SUCCESS = 'INVESTMENT_STATISTIC_REPORT_SUCCESS'
